export const REDUCER_MANAGEMENT_GET_DATA = 'REDUCER_MANAGEMENT_GET_DATA'
export const REDUCER_MANAGEMENT_CLEAR = 'REDUCER_MANAGEMENT_CLEAR'

export const REDUCER_MANAGEMENT_EDIT_MODE_CHANGE_TITLE = 'REDUCER_MANAGEMENT_EDIT_MODE_CHANGE_TITLE'
